/* eslint-disable no-else-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unused-state */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component, createElement } from "react";
import { bool, func, shape, string, arrayOf } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { Col } from "react-bootstrap";
import { isIOS } from "react-device-detect";
import { push } from "react-router-redux";
import Select from "react-select";
import {
    ScrollerX,
    Separator,
    Button as UiButton,
    SelectField,
    Tooltip as UiTooltip,
    Icon,
    Box,
} from "@ui-kit/components/index.es";

import { actions as transactionsActions, selectors as transactionsSelectors, actions } from "reducers/transactions";
import { actions as layoutActions } from "reducers/layout";
import * as i18n from "util/i18n";
import { selectors as sessionSelectors } from "reducers/session";
import { getTransferActivityName } from "util/transferInternalTitleLabels";

import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import List from "pages/transactions/_components/List";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import I18n from "pages/_components/I18n";
import SelectedTransactionsAmount from "pages/transactions/SelectedTransactionsAmount";
import classNames from "classnames";
import DownloadButton from "pages/_components/DownloadButton";
import { resizableRoute } from "pages/_components/Resizable";
import Tooltip from "pages/_components/tooltip/Tooltip";
import { actions as tooltipActions } from "reducers/tooltip";
import * as configUtils from "util/config";
import { actions as statusActions } from "reducers/status";
import {
    isMvp3PendingTransactionsEnabled,
    isMvp4PendingTransactionsEnabled,
    ALL_ACTIVITIES_VALUE,
    normalizeActivityId,
} from "util/transaction";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import PeriodFilterPendingTransactions from "./_components/PeriodFilterPendingTransactions";
import AmountFilterPendingTransactions from "./_components/AmountFilterPendingTransactions";
import FilterSelect from "./FilterSelect";

const FORM_ID = "pending.transactions";
const PENDING = "PENDING";
const PENDING_TOKEN = "PENDING_TOKEN";

const hasPendingAppliedFilters = (filters) => {
    if (!filters) {
        return false;
    }
    const activityApplied = !!filters.idActivity;
    const filterTypeApplied = !!filters.filter;
    const orderNonDefault =
        (filters.orderByName && filters.orderByName !== "creation_date_time") ||
        (filters.orderDirection && filters.orderDirection !== "descendent");
    return activityApplied || filterTypeApplied || orderNonDefault;
};

const components = {
    creationDate: PeriodFilterPendingTransactions,
    amount: AmountFilterPendingTransactions,
};

class PendingTransactionList extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        isDesktop: bool.isRequired,
        status: string.isRequired,
        pendingDispatch: bool,
        filters: shape({}).isRequired,
        activeEnvironment: shape({}).isRequired,
        location: shape({}).isRequired,
        activities: arrayOf(shape({})).isRequired,
        selectedTransactionRows: arrayOf().isRequired,
        fetchingMore: bool.isRequired,
        isDownload: bool.isRequired,
        showFilters: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        pendingDispatch: false,
        embeddedInV3Shell: false,
    };

    constructor(props) {
        super(props);
        const isMvp3 = isMvp3PendingTransactionsEnabled();
        this.state = {
            selectedFilter: props.filters?.filter || null,
            activitySelected: props.filters?.idActivity || (isMvp3 ? ALL_ACTIVITIES_VALUE : undefined),
            dataSelected: {},
            widthScreen: window.innerWidth,
            cleanFilter: false,
            filtered: false,
            orderBy: "creation_date_time DESC",
            filtersByStatus: {},
        };
    }

    componentDidMount = () => {
        const { dispatch, location, activities, filters } = this.props;
        const fromEcomexConfirm = location?.state?.from === "ecomexConfirm";
        const initialTab = location?.state?.initialTab;
        const isMvp3 = isMvp3PendingTransactionsEnabled();
        if (!activities) {
            dispatch(transactionsActions.loadTransactionActivitiesRequest());
        }
        if (initialTab) {
            this.changeFilterType(initialTab, true);
        } else if (!isMvp3) {
            if (!filters) {
                this.changeFilterType(PENDING, true);
            }
            if (fromEcomexConfirm) {
                this.changeFilterType(PENDING_TOKEN, true);
            }
            if (this.isScheduled()) {
                dispatch(transactionsActions.loadListRequest({ ...filters, status: filters?.status }, true, false));
            }
        } else if (!filters) {
            this.changeFilterType(PENDING, true);
        } else if (fromEcomexConfirm) {
            this.changeFilterType(PENDING_TOKEN, true);
        } else if (!filters?.status) {
            this.changeFilterType(PENDING, true);
        } else {
            const pendingDispatch = filters?.filter === "liberador";
            dispatch(transactionsActions.loadListRequest(filters, true, pendingDispatch));
        }
        if (!localStorage.getItem("flow") || localStorage.getItem("flow") !== "/pendingTransaction/list") {
            localStorage.setItem("flow", JSON.stringify("/pendingTransaction/list"));
        }
        dispatch(transactionsActions.saveTransactionRoute(location?.pathname));
        if (isIOS) {
            window.scrollTo(0, 1);
        }
        window.addEventListener("resize", this.updateWidthScreen);
        dispatch(statusActions.saveLastHref(location));
        this.applyEmbeddedV3Layout();
    };

    componentDidUpdate(prevProps, prevState) {
        const { widthScreen } = this.state;
        const { embeddedInV3Shell, isDesktop, status, isDownload, fetching, activeEnvironment } = this.props;
        if (prevState.widthScreen !== widthScreen) {
            this.updateWidthScreen();
        }
        if (prevProps.activeEnvironment?.idEnvironment !== activeEnvironment?.idEnvironment) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ filtersByStatus: {}, selectedFilter: null, cleanFilter: true });
        }
        const v3Relevant =
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.status !== status ||
            prevProps.isDownload !== isDownload ||
            prevProps.fetching !== fetching;
        if (v3Relevant) {
            if (prevProps.embeddedInV3Shell && !embeddedInV3Shell) {
                this.clearEmbeddedV3Layout();
            }
            this.applyEmbeddedV3Layout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell } = this.props;
        window.removeEventListener("resize", this.updateWidthScreen);
        if (embeddedInV3Shell) {
            this.clearEmbeddedV3Layout();
        }
    }

    clearEmbeddedV3Layout = () => {
        const { dispatch } = this.props;
        dispatch(layoutActions.setScopes([]));
        dispatch(layoutActions.setTitleKey(""));
        dispatch(layoutActions.setGoBackPath(null));
        dispatch(layoutActions.setRightContentMobile(null));
    };

    applyEmbeddedV3Layout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch, status, isDownload } = this.props;
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return;
        }
        dispatch(layoutActions.setScopes(["transactions"]));
        if (isDesktop) {
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
            return;
        }
        const downloadEnabled = status === "PENDING" || isMvp4PendingTransactionsEnabled();
        const shouldShowMobileDownload = downloadEnabled;
        let rightMobile = null;
        if (shouldShowMobileDownload) {
            rightMobile = isDownload ? this.rightContentDisabled() : this.rightContent();
        }
        dispatch(layoutActions.setTitleKey("pendingDispatch.list.title"));
        dispatch(layoutActions.setGoBackPath("/v3/dashboard"));
        dispatch(layoutActions.setRightContentMobile(rightMobile));
    };

    dataSelect = (columnFilter, changeFilter) => {
        this.setState({ dataSelected: { columnFilter, changeFilter } });
    };

    changeFilterType = (option, firstTime) => {
        const { dispatch, status, filters, showFilters } = this.props;
        const { filtered, filtersByStatus, selectedFilter, activitySelected } = this.state;
        if (firstTime || option !== status) {
            const isMvp3 = isMvp3PendingTransactionsEnabled();
            const updatedFiltersByStatus = { ...filtersByStatus };

            if (firstTime) {
                // El usuario limpió los filtros explícitamente: olvidar los guardados para esta pastilla
                delete updatedFiltersByStatus[option];
                dispatch(transactionsActions.setShowFilters(false));
            } else if (option !== status) {
                // Guardar los filtros actuales de la pastilla que se está abandonando
                updatedFiltersByStatus[status] = { selectedFilter, activitySelected, filters, showFilters };
                dispatch(transactionsActions.setShowFilters(false));
            }

            // Intentar restaurar filtros guardados de la pastilla destino (sólo si no es firstTime)
            const savedState = !firstTime && updatedFiltersByStatus[option];

            if (savedState) {
                this.setState({
                    activitySelected: savedState.activitySelected,
                    selectedFilter: savedState.selectedFilter,
                    cleanFilter: false,
                    filtered: false,
                    filtersByStatus: updatedFiltersByStatus,
                });
                dispatch(actions.changeStatusType(option));
                dispatch(transactionsActions.setShowFilters(savedState.showFilters ?? false));
                const pendingDispatch = savedState.filters?.filter === "liberador";
                dispatch(
                    transactionsActions.loadListRequest(
                        { ...savedState.filters, status: option },
                        true,
                        pendingDispatch,
                    ),
                );
            } else {
                const { dateFrom, dateTo } = this.getDefaultDateRange(option);
                const cleanFilters = {
                    pageNumber: 1,
                    filter: undefined,
                    status,
                    filterPendingDispatch: false,
                    functionRequest: "pendingTransactions",
                    dateFrom,
                    dateTo,
                    orderBy: "creation_date_time DESC",
                };
                this.setState({
                    activitySelected: isMvp3 ? ALL_ACTIVITIES_VALUE : undefined,
                    selectedFilter: null,
                    cleanFilter: true,
                    filtersByStatus: updatedFiltersByStatus,
                });
                dispatch(actions.changeStatusType(option));
                dispatch(transactionsActions.loadListRequest({ ...cleanFilters, status: option }, true, false));
            }

            dispatch(tooltipActions.clearActiveTooltip());
            dispatch(transactionsActions.clearMultipleSignaturesData());
        }
        if (filtered) {
            this.setState({ filtered: false });
        }
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push("/desktop/"));
    };

    filterButtons = (isMvp3) => {
        const { status, isDesktop, activeEnvironment } = this.props;
        const stateFilters = [];
        if (activeEnvironment?.administrationScheme !== "simple") {
            stateFilters.push("PENDING");
        }

        if (isDesktop) {
            stateFilters.push("SCHEDULED", "SCHEDULED_RECURRENT", "DRAFT", "PENDING_TOKEN", "ALL");
        } else {
            stateFilters.push("SCHEDULED", "SCHEDULED_RECURRENT", "DRAFT", "ALL");
        }

        const buttons = stateFilters.map((option, idx) => {
            const label = FORM_ID.concat(".", option.toLowerCase(), `${isDesktop ? "" : ".mobile"}`);
            const button = (
                <Button
                    key={option}
                    className="btn-outline btn-regular"
                    block={false}
                    image={status === option ? "images/check.svg" : ""}
                    style={{
                        borderRadius: "25px",
                        textTransform: "none",
                        fontWeight: "400",
                        padding: "8px 8px",
                        marginRight: !isDesktop && isMvp3 ? "0" : "1rem",
                        backgroundColor: status === option && "#f2f8fd",
                        borderColor: status === option ? "#0071ce" : "#666666",
                        color: status === option ? "#0071ce" : "#666666",
                        ...(!isDesktop && !isMvp3 && { width: "100%" }),
                        ...(!isDesktop && isMvp3 && { whiteSpace: "nowrap" }),
                        ...(!isDesktop &&
                            !isMvp3 && {
                                paddingTop: label.includes("pending.transactions.scheduled_recurrent.mobile") && "0px",
                                paddingBottom:
                                    label.includes("pending.transactions.scheduled_recurrent.mobile") && "0px",
                            }),
                    }}
                    onClick={() => this.changeFilterType(option)}
                    label={label}
                />
            );

            if (isDesktop) {
                return button;
            }

            if (isMvp3) {
                return (
                    <div key={option} style={{ flex: "0 0 auto" }}>
                        {button}
                    </div>
                );
            }

            return (
                <div
                    key={option}
                    style={{
                        width: stateFilters.length - 1 === idx ? "100%" : "50%",
                        paddingLeft: "1%",
                        paddingRight: "1%",
                    }}>
                    {button}
                </div>
            );
        });

        if (isDesktop) {
            return buttons;
        }

        if (isMvp3) {
            return (
                <div className="ml-2">
                    <ScrollerX spaceBetween={4}>{buttons}</ScrollerX>
                </div>
            );
        }

        return <div style={{ display: "flex", flexWrap: "wrap" }}>{buttons}</div>;
    };

    handleChange = (option) => {
        this.setState({ selectedFilter: option ? option.value : null });
    };

    cleanSelectedRows = () => {
        const { dispatch } = this.props;
        dispatch(transactionsActions.clearSelectedTransactionRows());
    };

    renderFilter = (isMvp3) => {
        const { selectedFilter, activitySelected, widthScreen } = this.state;
        const { dispatch, fetching, pendingDispatch, status, filters, isDesktop } = this.props;
        if (!selectedFilter || (selectedFilter !== "amount" && selectedFilter !== "creationDate")) {
            return null;
        }

        const defaults = this.getDefaultDateRange(status);
        const props = {
            dispatch,
            isDesktop: true,
            fetching,
            onlyPendings: true,
            pendingDispatch,
            className: "cmf-button-width",
            status,
            idActivity: normalizeActivityId(activitySelected),
            buttonLabel: "transactions.filter.button",
            marginTopButton: false,
            cleanSelectedRows: this.cleanSelectedRows,
            minAmount: filters?.minAmount,
            maxAmount: filters?.maxAmount,
            dateTo: selectedFilter === "creationDate" ? filters?.dateTo ?? defaults.dateTo : undefined,
            dateFrom: selectedFilter === "creationDate" ? filters?.dateFrom ?? defaults.dateFrom : undefined,
            cleanFiltersButton: this.cleanFiltersButton(isMvp3),
            renderOrder: this.renderOrderBy(isMvp3),
            selectedFilter,
            filters,
            isMobileMvp3: !isDesktop && isMvp3,
            isMvp3,
        };

        const amountFilterUsesFullWidth = (isMvp3 && selectedFilter === "amount") || widthScreen < 1580;
        const amountDateFilterLg = amountFilterUsesFullWidth ? 12 : 8;

        return (
            <Col
                xs={12}
                md={12}
                lg={amountDateFilterLg}
                className={classNames("pending-transactions__amount-date", {
                    "pl-3": isMvp3,
                    "pl-0": !isMvp3,
                    "pr-3": !isMvp3 || isDesktop,
                    "pending-transactions__amount-date--mvp3": isMvp3,
                })}>
                {createElement(components[selectedFilter], { ...props })}
            </Col>
        );
    };

    setActivityInState = ({ value }) => {
        this.setState({ activitySelected: value });
    };

    selectActivity = ({ value }) => {
        this.setState({ activitySelected: value });
        this.refreshTransactionList(value);
        this.setState((prevState) => ({
            ...prevState,
            filtered: true,
        }));
    };

    isScheduled = () => {
        const { filters } = this.props;
        if (filters?.status === "SCHEDULED" || filters?.status === "SCHEDULED_RECURRENT") {
            return true;
        }
        return false;
    };

    getDefaultDateRange = (statusKey) => {
        const limitMonths = this.getLimitMonth(statusKey);
        const dateFrom = new Date();
        dateFrom.setMonth(dateFrom.getMonth() - limitMonths);
        const dateTo = new Date();
        return { dateFrom, dateTo };
    };

    resolveDateRangeForPendingList = (filters, statusKey, selectedFilter) => {
        const defaults = this.getDefaultDateRange(statusKey);
        if (
            filters?.dateFrom &&
            filters?.dateTo &&
            (filters?.filter === "creationDate" || selectedFilter === "creationDate")
        ) {
            return { dateFrom: filters.dateFrom, dateTo: filters.dateTo };
        }
        return defaults;
    };

    getLimitMonth = (status) => {
        if (status === "PENDING") {
            return configUtils.getInteger("frontend.myPendingTransactions.allowedPeriod.Months", 12);
        }
        if (status === "SCHEDULED") {
            return configUtils.getInteger("frontend.scheduledTransactions.allowedPeriod.Months", 36);
        }
        if (status === "SCHEDULED_RECURRENT") {
            return configUtils.getInteger("frontend.recurringScheduledTransactions.allowedPeriod.Months", 36);
        }
        if (status === "DRAFT") {
            return configUtils.getInteger("frontend.draftsTransactions.allowedPeriod.Months", 6);
        }
        if (status === "PENDING_TOKEN") {
            return configUtils.getInteger("frontend.pendingToken.allowedPeriod.Months", 12);
        }
        return configUtils.getInteger("frontend.pendingTransactions.allowedPeriod.Months", 12);
    };

    filterTransactions = () => {
        this.refreshTransactionList();
        this.setState((prevState) => ({
            ...prevState,
            filtered: true,
        }));
    };

    refreshTransactionList = (selectActivity) => {
        const { dispatch, status, filters } = this.props;
        const { selectedFilter, activitySelected } = this.state;
        const rawActivity = selectActivity || activitySelected;
        const idActivity = normalizeActivityId(rawActivity);

        this.cleanSelectedRows();

        const { dateFrom, dateTo } = this.resolveDateRangeForPendingList(filters, status, selectedFilter);
        const orderFilters = {
            ...filters,
            dateFrom,
            dateTo,
            pageNumber: 1,
            filter: selectedFilter,
            status: status || "PENDING",
            idActivity,
            filterPendingDispatch: selectedFilter !== null,
            functionRequest: "pendingTransactions",
        };
        const pendingDispatch = selectedFilter === "liberador";
        dispatch(transactionsActions.loadListRequest(orderFilters, true, pendingDispatch));
    };

    addMultipleSelectedRow = (checked, transaction) => {
        const { dispatch } = this.props;
        if (checked) {
            dispatch(transactionsActions.saveSelectedTransactionRows(transaction));
        } else {
            dispatch(transactionsActions.removeSelectedTransactionRows(transaction));
        }
    };

    montoOperaciones = () => {
        const { isDesktop, selectedTransactionRows } = this.props;
        return (
            <SelectedTransactionsAmount
                selectedTransactionRows={selectedTransactionRows}
                isDesktop={isDesktop}
                withoutData={selectedTransactionRows}
                onlySelected={isMvp3PendingTransactionsEnabled()}
            />
        );
    };

    multipleSigns = () => {
        const { dispatch, activities, selectedTransactionRows, filters } = this.props;

        const completeActivity = activities.find((activity) => activity.idActivity === filters.idActivity);

        dispatch(
            transactionsActions.setMultipleSignaturesData({
                activitySelected: completeActivity,
                selectedTransactionRows,
                selectedRows: selectedTransactionRows.map((t) => t.transaction.idTransaction),
                filtered: true,
            }),
        );
        dispatch(
            transactionsActions.multipleSignaturesDataRequest({
                activitySelected: completeActivity,
                selectedTransactionRows,
            }),
        );
    };

    deleteMultipleSigns = () => {
        const { dispatch, activities, selectedTransactionRows, filters } = this.props;

        const completeActivity = activities.find((activity) => activity.idActivity === filters.idActivity);

        dispatch(
            transactionsActions.setMultipleSignaturesData({
                activitySelected: completeActivity,
                selectedTransactionRows,
                selectedRows: selectedTransactionRows.map((t) => t.transaction.idTransaction),
                filtered: true,
            }),
        );
        dispatch(push("/pendingTransaction/deleteMultiple"));
    };

    centerContentMobile = () => (
        <div className="pending-transactions-mobile-head-title">
            <h1 className="m-0">{i18n.get("pendingDispatch.list.title")}</h1>
        </div>
    );

    rightContent = () => {
        const pendingTransactionsFunctionalities = configUtils.getBoolean(
            "backend.show.PendingTransactions.functionalities",
            false,
        );
        const isMvp4 = isMvp4PendingTransactionsEnabled();

        return (
            <>
                {pendingTransactionsFunctionalities && (
                    <div className="pending-transaction-dropdown d-flex">
                        {isMvp4 && (
                            <UiTooltip
                                withShadow
                                id="pending-transactions-download-tooltip-desktop"
                                label={i18n.get("transactions.list.tooltip.message.approved")}
                                arrowPlacement="right"
                                placement="bottom">
                                <Icon name="Info" variant="outline" size={20} color="white-color" />
                            </UiTooltip>
                        )}
                        <Button
                            image="images/download_bold_white.svg"
                            className="button-white-header"
                            onClick={() => this.handleDownloadClick("pdf")}
                            bsStyle="outline"
                        />
                    </div>
                )}
            </>
        );
    };

    rightContentDisabled = () => {
        const pendingTransactionsFunctionalities = configUtils.getBoolean(
            "backend.show.PendingTransactions.functionalities",
            false,
        );
        const isMvp4 = isMvp4PendingTransactionsEnabled();

        return (
            <>
                {pendingTransactionsFunctionalities && (
                    <div className="pending-transaction-dropdown d-flex">
                        {isMvp4 && (
                            <Box align="center" mx={8}>
                                <UiTooltip
                                    id="pending-transactions-download-tooltip-desktop-disabled"
                                    label={i18n.get("transactions.list.tooltip.message.approved")}
                                    arrowPlacement="right"
                                    placement="bottom">
                                    <Icon name="Info" variant="outline" size={20} color="white-color" />
                                </UiTooltip>
                            </Box>
                        )}
                        <Button
                            image="images/download_bold_white.svg"
                            className="button-white-header"
                            bsStyle="outline"
                            disabled
                        />
                    </div>
                )}
            </>
        );
    };

    hasFiltersChanged = (isMvp3) => {
        const { filters } = this.props;
        const { activitySelected, selectedFilter } = this.state;
        const initialActivity = isMvp3 ? ALL_ACTIVITIES_VALUE : undefined;
        if (isMvp3) {
            return activitySelected !== initialActivity || selectedFilter !== null || filters?.idActivity;
        }
        return !!activitySelected || !!filters?.idActivity;
    };

    hasUnappliedFilterChanges = () => {
        const { filters } = this.props;
        const { activitySelected, selectedFilter } = this.state;
        const appliedActivity = filters?.idActivity || null;
        const normalizedSelected = normalizeActivityId(activitySelected) || null;
        const appliedFilter = filters?.filter || null;
        return normalizedSelected !== appliedActivity || selectedFilter !== appliedFilter;
    };

    cleanFiltersButton = (isMvp3) => {
        const { fetching, isDesktop } = this.props;
        if (this.hasFiltersChanged(isMvp3)) {
            const cleanFiltersClassName =
                !isDesktop && isMvp3
                    ? "clean-filters-label font-light filter-button my-0"
                    : "clean-filters-label font-light filter-button my-0 w-100";
            const button = (
                <Button
                    label="global.clean.filters"
                    className={cleanFiltersClassName}
                    onClick={() => this.changeFilterType(PENDING, true)}
                    image="images/cross.svg"
                    imageStyle="circle-cross"
                    disabled={fetching}
                />
            );
            if (!isDesktop && isMvp3) {
                return <div className="d-flex justify-content-end">{button}</div>;
            }
            return button;
        }
        return null;
    };

    toggleFilters = () => {
        const { dispatch, showFilters } = this.props;
        dispatch(transactionsActions.setShowFilters(!showFilters));
    };

    getPendingFiltersToggleText = () => {
        const { showFilters, filters } = this.props;
        if (showFilters) {
            return i18n.get(`${FORM_ID}.hideFilters`);
        }
        if (hasPendingAppliedFilters(filters)) {
            return i18n.get(`${FORM_ID}.activeFilters`);
        }
        return i18n.get(`${FORM_ID}.showFilters`);
    };

    updateWidthScreen = () => {
        this.setState({ widthScreen: window.innerWidth });
    };

    updateCols = () => {
        const { widthScreen, activitySelected } = this.state;
        if (widthScreen >= 1920 && activitySelected) {
            return 2;
        } else if (widthScreen >= 1920 && !activitySelected) {
            return 2;
        } else if (widthScreen < 1920 && !activitySelected) {
            return 3;
        }
        return 3;
    };

    renderOrderBy = (isMvp3) => {
        const { selectedFilter, activitySelected } = this.state;
        const { isDesktop } = this.props;
        const isMobileMvp3 = !isDesktop && isMvp3;
        const options = [
            {
                value: "creationDate",
                label: i18n.get("transactions.filters.searchBy.creationDate"),
            },
            {
                value: "amount",
                label: i18n.get("accounts.movements.filters.searchBy.amount"),
            },
            {
                value: "liberador",
                label: i18n.get("transaction.to.liberate"),
            },
            {
                value: "pending",
                label: i18n.get("transaction.to.sign"),
            },
        ];
        const selectedFilterOption = options.find(({ value }) => value === selectedFilter) || null;
        return (
            <>
                <Col
                    sm={12}
                    md={3}
                    lg={3}
                    className={
                        activitySelected
                            ? "w100 px-0 pending-transactions__search-by"
                            : "px-0 pending-transactions__search-by"
                    }>
                    {isMobileMvp3 ? (
                        <>
                            <SelectField
                                id="searchByOrder"
                                selectLabel={i18n.get("accounts.movements.filters.searchBy")}
                                iconMobile="Commands"
                                searchable={false}
                                onSelectOption={this.handleChange}
                                options={options}
                                value={selectedFilterOption}
                                placeholder={i18n.get("transactions.filters.placeholder")}
                                noOptionsMessage={i18n.get("global.no.results")}
                            />
                        </>
                    ) : (
                        <>
                            <div className="form-group-text">
                                <label htmlFor="searchBy" className="control-label">
                                    <I18n id="accounts.movements.filters.searchBy" />
                                </label>
                            </div>
                            <Select
                                name="searchBy"
                                className="input-group"
                                clearable={false}
                                searchable={false}
                                onChange={this.handleChange}
                                options={options}
                                value={selectedFilter}
                                optionClassName="needsclick"
                                placeholder={i18n.get("transactions.filters.placeholder")}
                                noResultsText={i18n.get("global.no.results")}
                            />
                        </>
                    )}
                </Col>
            </>
        );
    };

    handleDownloadClick = (format) => {
        const { dispatch, filters } = this.props;
        const { selectedFilter } = this.state;

        const filterPendingDispatch = selectedFilter !== null;
        const functionRequest = "pendingTransactions";
        const pendingDispatch = selectedFilter === "liberador";
        dispatch(
            transactionsActions.downloadPendingTransactionsRequest(
                {
                    ...filters,
                    pageNumber: 1,
                    filterPendingDispatch,
                    functionRequest,
                },
                true,
                pendingDispatch,
                format,
            ),
        );
    };

    handleFilterButtonsClick = (orderByName, orderDirection) => {
        const { filters, status } = this.props;
        const { selectedFilter } = this.state;

        const { dateFrom, dateTo } = this.resolveDateRangeForPendingList(filters, status, selectedFilter);
        let orderFilters = { filters };
        const order = orderDirection === "ascendent" ? " ASC" : " DESC";
        orderFilters = {
            ...filters,
            dateFrom,
            dateTo,
            orderBy: orderByName + order,
            orderByName,
            orderDirection,
            pageNumber: 1,
        };
        const { dispatch } = this.props;
        const pendingDispatch = selectedFilter === "liberador";
        dispatch(transactionsActions.loadListRequest(orderFilters, true, pendingDispatch));
    };

    setOrder = (orderByName, orderDirection) => {
        const { dispatch, filters } = this.props;
        dispatch(
            transactionsActions.setFilters({
                ...filters,
                orderByName,
                orderDirection,
            }),
        );

        this.handleFilterButtonsClick(orderByName, orderDirection);
    };

    render() {
        const {
            fetching,
            isDesktop,
            status,
            selectedTransactionRows,
            activities,
            fetchingMore,
            isDownload,
            filters,
            showFilters,
        } = this.props;
        const {
            defaultFilters,
            selectedFilter,
            activitySelected,
            dataSelected,
            widthScreen,
            cleanFilter,
            filtered,
        } = this.state;
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const options = [
            {
                value: "creationDate",
                label: i18n.get("transactions.filters.searchBy.creationDate"),
            },
            {
                value: "amount",
                label: i18n.get("accounts.movements.filters.searchBy.amount"),
            },
            {
                value: "liberador",
                label: i18n.get("transaction.to.liberate"),
            },
            {
                value: "pending",
                label: i18n.get("transaction.to.sign"),
            },
        ];

        const orderByOptions = [
            {
                value: "id_activity",
                label: i18n.get("accounts.movements.filters.searchBy.transaction"),
            },
            {
                value: "total_amount_data",
                label: i18n.get("accounts.movements.filters.searchBy.amount"),
            },
            {
                value: "creation_date_time",
                label: i18n.get("transactions.filters.searchBy.creationDate"),
            },
        ];

        const orderOptions = [
            {
                id: "0",
                label: <I18n id="accounts.movements.filters.searchBy.upward" />,
            },
            {
                id: "1",
                label: <I18n id="accounts.movements.filters.searchBy.falling" />,
            },
        ];

        const isMvp3 = isMvp3PendingTransactionsEnabled();
        const isMvp4 = isMvp4PendingTransactionsEnabled();
        const isMobileMvp3 = !isDesktop && isMvp3;
        const activityOptions =
            activities && activities.length > 0
                ? [
                      ...(isMvp3
                          ? [{ value: ALL_ACTIVITIES_VALUE, label: i18n.get("transactions.list.filters.all") }]
                          : []),
                      ...activities.map(({ activityName, idActivity }) => ({
                          value: idActivity,
                          label: getTransferActivityName(idActivity, activityName),
                      })),
                  ]
                : [];
        const activitySelectedOption = activityOptions?.find(({ value }) => value === activitySelected);
        const selectedFilterOption = options.find(({ value }) => value === selectedFilter) || null;
        const pendingTransactionsFunctionalities = configUtils.getBoolean(
            "backend.show.PendingTransactions.functionalities",
            false,
        );

        const downloadEnabled = status === "PENDING" || isMvp4;
        const activityForLayout = status === "PENDING" ? activitySelected : normalizeActivityId(activitySelected);
        let mdCols = 12;
        if (
            !activityForLayout ||
            (activityForLayout && selectedFilter !== "amount" && selectedFilter !== "creationDate")
        ) {
            mdCols = 8;
        }
        const getOffset = (a, b, c, d, offsetType) => {
            if (!activityForLayout) {
                return a;
            }
            if (offsetType === "mdOffset") {
                if (activityForLayout && selectedFilter !== "amount" && selectedFilter !== "creationDate") {
                    return b;
                }
                if ((selectedFilter === "amount" || selectedFilter === "creationDate") && widthScreen < 1200) {
                    return c;
                }
            }
            if (offsetType === "lgOffset") {
                if (
                    activityForLayout &&
                    selectedFilter !== "amount" &&
                    selectedFilter !== "creationDate" &&
                    widthScreen >= 1580
                ) {
                    return b;
                }
                if ((selectedFilter === "amount" || selectedFilter === "creationDate") && widthScreen < 1580) {
                    return c;
                }
            }
            return d;
        };

        const shouldShowMobileDownload = !isDesktop && downloadEnabled;
        const mobileDownloadContent = isDownload ? this.rightContentDisabled : this.rightContent;
        const rightContent = shouldShowMobileDownload ? mobileDownloadContent : null;
        const { embeddedInV3Shell } = this.props;
        const showLegacyHead = isDesktop || !embeddedInV3Shell;

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="transactions" />}
                {showLegacyHead && (
                    <div
                        className={classNames("admin-detail-head pl-0 pr-1", {
                            "admin-detail-head--pending-mvp4-actions":
                                !isDesktop && pendingTransactionsFunctionalities && isMvp4,
                        })}>
                        <Head
                            onBack={this.handleBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                            centerContentClassName={classNames({
                                "mx-5": isDesktop || !pendingTransactionsFunctionalities || !isMvp4,
                            })}
                            rightContent={rightContent}
                            accessibilityTextId="pendingDispatch.list.title"
                        />
                        {isDesktop && (
                            <div className="d-flex">
                                <div className="d-flex align-items-center w-100 space-between mb-3">
                                    <div className="d-flex align-items-center">
                                        <I18n
                                            component="h1"
                                            componentProps={{ className: "view-title mb-0" }}
                                            id="pendingDispatch.list.title"
                                        />
                                    </div>
                                    {pendingTransactionsFunctionalities && (
                                        <div className="d-flex align-items-center">
                                            <Tooltip
                                                id="pending-transactions-tooltip"
                                                activeTooltip="pending-transactions-tooltip"
                                                message={
                                                    isMvp4 ? (
                                                        <I18n id="transactions.list.tooltip.message.approved" />
                                                    ) : (
                                                        <I18n id="transactions.list.tooltip.message" />
                                                    )
                                                }
                                                left
                                                messageClass="pending-transactions__tooltip"
                                            />
                                            <DownloadButton
                                                fetching={fetching}
                                                handleClickMessage="global.download"
                                                csvDownload
                                                xlsDownload
                                                imageStyle="mr-2"
                                                handleClick={this.handleDownloadClick}
                                                btnClass="min-width-14"
                                                exportDisabled={!downloadEnabled}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <div>
                    <Container className="container--layaut flex-grow container-white mt-1">
                        <div className="w-100 my-2 mx-3">
                            {isDesktop && isMvp3 ? (
                                <div className="d-flex align-items-center w-100">
                                    <div className="d-flex align-items-center">{this.filterButtons(isMvp3)}</div>
                                    {status === PENDING && (
                                        <div className="ml-auto d-flex flex-column">
                                            <UiButton
                                                text={this.getPendingFiltersToggleText()}
                                                iconVariant="outline"
                                                variant="outline"
                                                size="medium"
                                                icon={showFilters ? "EyeOff" : "Eye"}
                                                onClick={this.toggleFilters}
                                            />
                                            {!showFilters && hasPendingAppliedFilters(filters) && (
                                                <UiButton
                                                    text={i18n.get("global.clean.filters")}
                                                    variant="text"
                                                    size="small"
                                                    icon="Error"
                                                    className="ml-2"
                                                    disabled={fetching}
                                                    onClick={() => this.changeFilterType(PENDING, true)}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <>
                                    {this.filterButtons(isMvp3)}
                                    {!isDesktop && isMvp3 && status === PENDING && (
                                        <div className="d-flex justify-content-start mt-2 ml-3">
                                            <UiButton
                                                text={this.getPendingFiltersToggleText()}
                                                iconVariant="outline"
                                                variant="outline"
                                                size="small"
                                                icon={showFilters ? "EyeOff" : "Eye"}
                                                onClick={this.toggleFilters}
                                            />
                                            {!showFilters && hasPendingAppliedFilters(filters) && (
                                                <UiButton
                                                    text={i18n.get("global.clean.filters")}
                                                    variant="text"
                                                    size="small"
                                                    icon="Error"
                                                    className="ml-2"
                                                    disabled={fetching}
                                                    onClick={() => this.changeFilterType(PENDING, true)}
                                                />
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </Container>
                    {(!isMvp3 || showFilters) && (
                        <Container
                            gridClassName="p-0"
                            rowClassName={
                                isDesktop
                                    ? `my-2 mx-0 container-white d-flex pending-transactions__filter ${
                                          status !== "PENDING" ? "justify-content-end" : null
                                      }`
                                    : "mt-2 mb-0 mx-0"
                            }>
                            {status === "PENDING" && (
                                <Col sm={12} md={4} lg={3} className="px-0">
                                    <Col sm={12} lg={12} md={12} className={isDesktop ? "pr-0" : ""}>
                                        {isMobileMvp3 ? (
                                            <>
                                                <SelectField
                                                    id="activity"
                                                    selectLabel={i18n.get(
                                                        "transactions.list.filters.transaction.activity.label",
                                                    )}
                                                    iconMobile="Commands"
                                                    searchable={false}
                                                    onSelectOption={this.setActivityInState}
                                                    options={activityOptions}
                                                    placeholder={i18n.get("transactions.filters.placeholder")}
                                                    value={activitySelectedOption}
                                                    noOptionsMessage={i18n.get("global.no.results")}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <div className="form-group-text">
                                                    <label htmlFor="activity" className="control-label">
                                                        <I18n id="transactions.list.filters.transaction.activity.label" />
                                                    </label>
                                                </div>
                                                <div className="input-group">
                                                    <Select
                                                        name="activity"
                                                        className="slideFromBottom"
                                                        clearable={false}
                                                        searchable={isDesktop}
                                                        onChange={
                                                            isDesktop || isMvp3
                                                                ? this.setActivityInState
                                                                : this.selectActivity
                                                        }
                                                        options={activityOptions}
                                                        optionClassName="needsclick"
                                                        placeholder={i18n.get("transactions.filters.placeholder")}
                                                        value={activitySelected}
                                                        noResultsText={i18n.get("global.no.results")}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </Col>
                                </Col>
                            )}
                            <Col
                                sm={12}
                                md={mdCols}
                                lg={status === "PENDING" ? 9 : 3}
                                className={classNames("px-0 filters my-0", {
                                    "pb-4": isDesktop,
                                    "pb-1": !isDesktop,
                                    "mt-2": !isDesktop && isMvp3,
                                })}>
                                {status === "PENDING" && (
                                    <Container rowClassName="">
                                        {isMvp3 &&
                                            activitySelected &&
                                            selectedFilter !== "amount" &&
                                            selectedFilter !== "creationDate" && (
                                                <Col sm={12} md={3} lg={3} className="pending-transactions__search-by">
                                                    {isMobileMvp3 ? (
                                                        <>
                                                            <SelectField
                                                                id="searchBy"
                                                                selectLabel={i18n.get(
                                                                    "accounts.movements.filters.searchBy",
                                                                )}
                                                                iconMobile="Commands"
                                                                searchable={false}
                                                                onSelectOption={this.handleChange}
                                                                options={options}
                                                                value={selectedFilterOption}
                                                                placeholder={i18n.get(
                                                                    "transactions.filters.placeholder",
                                                                )}
                                                                noOptionsMessage={i18n.get("global.no.results")}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="form-group-text">
                                                                <label htmlFor="searchBy" className="control-label">
                                                                    <I18n id="accounts.movements.filters.searchBy" />
                                                                </label>
                                                            </div>
                                                            <Select
                                                                name="searchBy"
                                                                className="input-group"
                                                                clearable={false}
                                                                searchable={false}
                                                                onChange={this.handleChange}
                                                                options={options}
                                                                value={selectedFilter}
                                                                optionClassName="needsclick"
                                                                placeholder={i18n.get(
                                                                    "transactions.filters.placeholder",
                                                                )}
                                                                noResultsText={i18n.get("global.no.results")}
                                                            />
                                                        </>
                                                    )}
                                                </Col>
                                            )}
                                        {(selectedFilter === "liberador" ||
                                            selectedFilter === "pending" ||
                                            !selectedFilter) &&
                                            (isDesktop || isMvp3) && (
                                                <Col
                                                    sm={12}
                                                    md={4}
                                                    lg={3}
                                                    className="d-flex f-dir-col mt-35 pt-3 pl-3 pr-3 position-relative">
                                                    <Button
                                                        bsStyle="primary"
                                                        label="transactions.filter.button"
                                                        loading={fetching}
                                                        onClick={() => this.filterTransactions()}
                                                        type="submit"
                                                        image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                                                        imageStyle="mr-2"
                                                        className={classNames("filter-button m-0  w-100", {
                                                            "text-transform-none": enableNewSubmitButton,
                                                        })}
                                                        disabled={!this.hasUnappliedFilterChanges()}
                                                    />
                                                    {isDesktop && isMvp3 ? (
                                                        <div className="pending-transactions__clean-filters-absolute">
                                                            {this.cleanFiltersButton(isMvp3)}
                                                        </div>
                                                    ) : (
                                                        this.cleanFiltersButton(isMvp3)
                                                    )}
                                                </Col>
                                            )}
                                        {!isMvp3 &&
                                            activitySelected &&
                                            isDesktop &&
                                            selectedFilter !== "amount" &&
                                            selectedFilter !== "creationDate" && (
                                                <Col
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                    className={classNames("pending-transactions__search-by", {
                                                        "pr-0":
                                                            selectedFilter === "amount" ||
                                                            selectedFilter === "creationDate",
                                                    })}>
                                                    <div className="form-group-text">
                                                        <label htmlFor="searchBy" className="control-label">
                                                            <I18n id="accounts.movements.filters.searchBy" />
                                                        </label>
                                                    </div>
                                                    <Select
                                                        name="searchBy"
                                                        className="input-group"
                                                        clearable={false}
                                                        searchable={false}
                                                        onChange={this.handleChange}
                                                        options={options}
                                                        value={selectedFilter}
                                                        optionClassName="needsclick"
                                                        placeholder={i18n.get("transactions.filters.placeholder")}
                                                        noResultsText={i18n.get("global.no.results")}
                                                    />
                                                </Col>
                                            )}
                                        {this.renderFilter(isMvp3)}
                                        {isDesktop && !isMvp3 && (
                                            <Col
                                                sm={12}
                                                md={
                                                    activitySelected &&
                                                    selectedFilter !== "amount" &&
                                                    selectedFilter !== "creationDate"
                                                        ? 3
                                                        : 6
                                                }
                                                mdOffset={getOffset(2, undefined, 8, undefined, "mdOffset")}
                                                lg={status === "PENDING" ? this.updateCols() : 12}
                                                lgOffset={getOffset(5, 2, 7, undefined, "lgOffset")}
                                                className={classNames({
                                                    "d-none": fetching,
                                                    "pl-0": widthScreen > 1200 || activitySelected,
                                                })}>
                                                <FilterSelect
                                                    className={classNames({
                                                        "orderby-column":
                                                            activitySelected &&
                                                            (!selectedFilter ||
                                                                (selectedFilter !== "amount" &&
                                                                    selectedFilter !== "creationDate")) &&
                                                            widthScreen < 1200,
                                                        "min-w100": widthScreen < 1200,
                                                    })}
                                                    orderByOptions={orderByOptions}
                                                    orderOptions={orderOptions}
                                                    isDesktop={isDesktop}
                                                    isMvp3={isMvp3}
                                                    columnFilter={dataSelected.columnFilter}
                                                    changeFilter={this.setOrder}
                                                    cleanFilter={cleanFilter}
                                                    setCleanFilter={(value) => this.setState({ cleanFilter: value })}
                                                    defaultOrderBy={
                                                        filters?.orderByName
                                                            ? orderByOptions.find(
                                                                  ({ value }) => value === filters?.orderByName,
                                                              )
                                                            : orderByOptions.find(
                                                                  ({ value }) => value === "creation_date_time",
                                                              )
                                                    }
                                                    defaultOrder={filters?.orderDirection || "descendent"}
                                                />
                                            </Col>
                                        )}
                                    </Container>
                                )}
                                {status !== "PENDING" && isDesktop && (
                                    <Col
                                        sm={12}
                                        md={
                                            activitySelected &&
                                            selectedFilter !== "amount" &&
                                            selectedFilter !== "creationDate"
                                                ? 3
                                                : 6
                                        }
                                        mdOffset={getOffset(2, undefined, 8, undefined, "mdOffset")}
                                        lg={12}
                                        lgOffset={getOffset(0, 2, 7, undefined, "lgOffset")}
                                        className={classNames({
                                            "d-none": fetching,
                                            "pl-0": widthScreen > 1200 || activitySelected,
                                        })}>
                                        <FilterSelect
                                            className={classNames({
                                                "orderby-column":
                                                    activitySelected &&
                                                    (!selectedFilter ||
                                                        (selectedFilter !== "amount" &&
                                                            selectedFilter !== "creationDate")) &&
                                                    widthScreen < 1200,
                                                "min-w100": widthScreen < 1200,
                                            })}
                                            orderByOptions={orderByOptions}
                                            orderOptions={orderOptions}
                                            isDesktop={isDesktop}
                                            isMvp3={isMvp3}
                                            columnFilter={dataSelected.columnFilter}
                                            changeFilter={this.setOrder}
                                            cleanFilter={cleanFilter}
                                            setCleanFilter={(value) => this.setState({ cleanFilter: value })}
                                            defaultOrderBy={
                                                filters?.orderByName
                                                    ? orderByOptions.find(({ value }) => value === filters?.orderByName)
                                                    : orderByOptions.find(({ value }) => value === "creation_date_time")
                                            }
                                            defaultOrder={filters?.orderDirection || "descendent"}
                                        />
                                    </Col>
                                )}
                            </Col>
                            {isMvp3 && status === "PENDING" && (
                                <Col sm={12} md={4} lg={3} className="px-3 pb-2 ">
                                    <FilterSelect
                                        orderByOptions={orderByOptions}
                                        orderOptions={orderOptions}
                                        isDesktop={isDesktop}
                                        isMvp3={isMvp3}
                                        columnFilter={dataSelected.columnFilter}
                                        changeFilter={this.setOrder}
                                        cleanFilter={cleanFilter}
                                        setCleanFilter={(value) => this.setState({ cleanFilter: value })}
                                        defaultOrderBy={
                                            filters?.orderByName
                                                ? orderByOptions.find(({ value }) => value === filters?.orderByName)
                                                : orderByOptions.find(({ value }) => value === "creation_date_time")
                                        }
                                        defaultOrder={filters?.orderDirection || "descendent"}
                                    />
                                </Col>
                            )}
                        </Container>
                    )}
                </div>
                {!isDesktop && isMvp3 && (
                    <Box mx={16}>
                        <Separator color="neutral-light" mt={24} />
                    </Box>
                )}
                <div>
                    <MainContainer
                        showLoader={fetching || (isDesktop && fetchingMore)}
                        loadingClassName="line-loader"
                        showChildrenWithLoader
                        className="main-container pending-transactions-container">
                        <List
                            isDesktop={isDesktop}
                            isMvp3={isMvp3}
                            activitySelected={filters?.idActivity}
                            showSearchButton
                            defaultFilters={defaultFilters}
                            onlyPendings
                            selectedTransactionRows={selectedTransactionRows}
                            addMultipleSelectedRow={this.addMultipleSelectedRow}
                            cleanSelectedRows={this.cleanSelectedRows}
                            selectedFilter={selectedFilter}
                            dataSelect={this.dataSelect}
                            filtered={activitySelected && filtered}
                            multipleSigns={this.multipleSigns}
                            deleteMultipleSigns={this.deleteMultipleSigns}
                            montoOperaciones={this.montoOperaciones}
                        />
                    </MainContainer>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const excludedActivities = [
        "echeq.admit.action",
        "echeq.anulate-echeq.action",
        "echeq.repudiate.action",
        "echeq.rescue.action",
        "echeq.custody.action",
        "echeq.deposit.action",
        "echeq.repudiate-return.action",
        "echeq.request-return.action",
        "core.forms.send",
        "fundcorp.register.rescue.request",
        "fundcorp.register.suscription.request",
        "fundcorp.cancel.send",
        "deposits.confirmDeposit",
        "cedip.reject",
        "manage.echeq.rules",
        "chargeback.pull",
        "chargeback.recurrency",
        "currencyExchange.confirm.buy",
        "currencyExchange.confirm.sell",
        "checkCPE.payments",
    ];

    return {
        fetching: transactionsSelectors.getFetching(state),
        pageNumber: transactionsSelectors.getPageNumber(state),
        filters: transactionsSelectors.getFilters(state),
        status: transactionsSelectors.getStatusType(state),
        transactions: transactionsSelectors.getTransactions(state),
        activeEnvironment: sessionSelectors.getActiveEnvironment(state),
        activities: transactionsSelectors.getFilteredActivities(state, excludedActivities),
        selectedTransactionRows: transactionsSelectors.getSelectedTransactionRows(state),
        fetchingMore: transactionsSelectors.isFetchingMore(state),
        isDownload: transactionsSelectors.getIsDownload(state),
        showFilters: transactionsSelectors.getShowFilters(state),
    };
};

export default compose(connect(mapStateToProps), resizableRoute)(PendingTransactionList);
